export default __webpack_public_path__ + "static/media/ISKO CLASS 7 SYLLABUS.e8d0d75b.pdf";